import lazyComponent from "./LazyComponent";
import "codemirror/lib/codemirror.css";

import App from "./App";
import AppProvider from "./AppProvider";
const ChallengeIndex = lazyComponent(() => import(/* webpackChunkName: "challengeindex" */ "./ChallengeIndex"));
const CodeConverter = lazyComponent(() => import(/* webpackChunkName: "codeconverter" */ "./CodeConverter"));
const CodeSnippet = lazyComponent(() => import(/* webpackChunkName: "codesnippet" */ "./CodeSnippet"));
const Content = lazyComponent(() => import(/* webpackChunkName: "content" */ "./Content"));
import CourseCurriculum from "./CourseCurriculum";
import FooterLinks from "./FooterLinks";
import ShareButtons from "./ShareButtons";
import Turbolinks from "turbolinks";
import UserCourseSendSelector from "./UserCourseSendSelector";
import WebpackerReact from "webpacker-react";

document.addEventListener("turbolinks:load", () => {
  Turbolinks.start();
  WebpackerReact.setup({
    App,
    AppProvider,
    ChallengeIndex,
    CodeConverter,
    Content,
    CourseCurriculum,
    CodeSnippet,
    FooterLinks,
    ShareButtons,
    UserCourseSendSelector,
  });
});
